import { Hint } from '@redoc/ui-kit';
import { IconButton } from 'src/Components';
import { RdcGroupItemType } from '.';
import { ReactComponent as StarNotFilled } from 'src/Themes/assets/StarNotFilled.svg';
import { ReactComponent as StartIcon } from 'src/Themes/assets/Icon Star.svg';
import { useSearchMark } from 'src/Hooks';
import { useState, MouseEvent, ReactNode, FC } from 'react';
import classNames from 'classnames';
import st from './RdcGroupItem.module.scss';

interface IRdcGroupItemProps {
	searchText: string;
	item: any;
	/** ИД родительской группы, нужен, чтобы DOM-id строки был уникален на странице */
	groupId: string;
	enableFavorite?: boolean;
	selectedIdList: string[];
	onAction: (e: MouseEvent, item: any, action: string) => void;
	renderItemTb?: (item: any) => ReactNode;
	onGetParams: (item: any) => RdcGroupItemType;
}

export const RdcGroupItem: FC<IRdcGroupItemProps> = (props) => {
	const {
		enableFavorite = false,
		item,
		groupId,
		searchText,
		selectedIdList,
		onAction,
		renderItemTb,
		onGetParams,
	} = props;

	const { getHtml } = useSearchMark();
	// Вычисляем при каждом рендере, чтобы отражать изменения item
	// (например, переключение «избранного») без перемонтирования
	const groupItem = onGetParams(item);

	const onActionHandler = (e: MouseEvent, actionName: string) => {
		e.preventDefault();
		e.stopPropagation();
		onAction(e, item, actionName);
	};

	const recid = 'textFor-' + groupItem.id;
	return (
		<div
			className={classNames(st.RdcGroupItem, {
				[st.selected]: selectedIdList.includes(groupItem.id),
			})}
			id={groupId + '-' + item.id}
			onClick={(e) => {
				return onActionHandler(e, 'itemClick');
			}}
		>
			{!!enableFavorite && (
				<div className={st.RdcGroupItem__toolbar_bef}>
					<Hint
						messageText={
							groupItem.isFavorite
								? 'Удалить из избранного'
								: 'Добавить в избранное'
						}
						placement="top"
					>
						<IconButton
							outline
							onClick={(e) => {
								return onActionHandler(e, 'toggleFavorite');
							}}
						>
							{groupItem.isFavorite ? (
								<StartIcon
									className={st.snf}
									width={32}
									height={32}
								/>
							) : (
								<StarNotFilled
									className={st.snf}
									width={32}
									height={32}
								/>
							)}
						</IconButton>
					</Hint>
				</div>
			)}
			<span
				id={recid}
				className="body-small"
				dangerouslySetInnerHTML={{
					__html: getHtml(groupItem.title, searchText),
				}}
			/>
			{!!renderItemTb && (
				<div className={st.RdcGroupItem__toolbar}>
					{renderItemTb(item)}
				</div>
			)}
		</div>
	);
};
